import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';

export const DashboardCard = ({
  icon,
  value,
  description,
  type,
  backgroundColor = undefined,
  text = undefined,
}) => {
  return (
    <Card
      className="p-2"
      bg={type}
      text={text ? text : 'white'}
      style={{
        backgroundColor: backgroundColor,
        margin: 5,
        border: '1px solid white',
      }}
    >
      <Row className="align-items-center">
        <Col xs={3}>
          {' '}
          <FontAwesomeIcon size="4x" icon={icon} />
        </Col>
        <Col xs={9} className="text-right">
          <div className="font" style={{fontSize: '40px'}}>
            {value}
          </div>
          <div>{description}</div>
        </Col>
      </Row>
    </Card>
  );
};

export const DashboardRow = ({header, children, id}) => {
  return (
    <Col id={id}>
      {header && <h2 style={{borderBottom: '1px solid #eee'}}>{header}</h2>}
      {children}
    </Col>
  );
};
